// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__19e6Z","title":"ClientInsurance_title__2Gmnn","itemText":"ClientInsurance_itemText__1hLoK"};